import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Invoice } from '../../../domain/entities/invoice.entity';
import { InvoiceAction } from '../../../domain/enums/invoice-action.enum';
import { InvoiceCardVm } from '../../view-models/invoice-card.vm';

export interface InvoiceCardActionEvent {
  invoice: Invoice;
  action: InvoiceAction;
}

@Component({
  selector: 'app-invoice-card-list',
  templateUrl: './invoice-card-list.component.html',
  styleUrls: ['./invoice-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceCardListComponent {
  @Input({ required: true }) cards: readonly InvoiceCardVm[] = [];
  @Output() actionSelected = new EventEmitter<InvoiceCardActionEvent>();

  onAction(card: InvoiceCardVm, action: InvoiceAction): void {
    this.actionSelected.emit({ invoice: card.invoice, action });
  }

  trackCard(_: number, card: InvoiceCardVm): number | string {
    return card.invoice.id;
  }
}
